
import React, { useState, useEffect } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { Card, CardContent } from '@/components/ui/card';
import { ErrorBoundaryBase } from '@/components/ErrorBoundary'; // Updated import

// Import our settings section components
import ProfileSettingsForm from '@/components/settings/new/ProfileSettingsForm';
import SecuritySettingsControls from '@/components/settings/new/SecuritySettingsControls';
import NotificationSettingsControls from '@/components/settings/new/NotificationSettingsControls';
import PrivacySettingsActions from '@/components/settings/new/PrivacySettingsActions';
import CustomDomainSettings from '@/components/settings/new/CustomDomainSettings';

// Constants
const SETTINGS_TAB_KEY = 'settings_new_active_tab';

const SettingsNew = () => {
  // Initialize tab state from sessionStorage or default to "account"
  const [activeTab, setActiveTab] = useState(() => {
    // TODO: Implement actual persistence logic
    const savedTab = sessionStorage.getItem(SETTINGS_TAB_KEY);
    return savedTab || "account";
  });

  // Update sessionStorage when tab changes
  useEffect(() => {
    // TODO: Implement actual persistence logic
    sessionStorage.setItem(SETTINGS_TAB_KEY, activeTab);
  }, [activeTab]);

  // Mock state for UI demonstration - will be replaced by real hooks later
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasError, setHasError] = useState(false);

  // Stub handler for the retry action when an error occurs
  const handleRetry = () => {
    console.log('Retry action triggered');
    setHasError(false);
    // TODO: Wire up actual retry logic
  };

  return (
    <div className="space-y-6">
      <h1 className="text-base font-medium">Settings</h1>
      
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <div className="bg-white p-3 rounded-lg shadow-[inset_0_2px_4px_rgba(0,0,0,0.05),inset_0_-2px_4px_rgba(0,0,0,0.05),inset_2px_0_4px_rgba(0,0,0,0.05),inset_-2px_0_4px_rgba(0,0,0,0.05)]">
          <TabsList className="h-auto bg-transparent p-0 justify-start">
            <div className="flex items-center gap-1 flex-wrap justify-start">
              <TabsTrigger
                value="account"
                className="px-3 py-1.5 text-sm font-medium rounded-md transition-all data-[state=active]:bg-white data-[state=active]:text-black data-[state=active]:shadow-md data-[state=active]:border data-[state=active]:border-gray-200 data-[state=inactive]:text-[#737373] data-[state=inactive]:font-medium data-[state=inactive]:bg-transparent"
                data-testid="settings-tab-account"
              >
                Account
              </TabsTrigger>
              <TabsTrigger
                value="notifications"
                className="px-3 py-1.5 text-sm font-medium rounded-md transition-all data-[state=active]:bg-white data-[state=active]:text-black data-[state=active]:shadow-md data-[state=active]:border data-[state=active]:border-gray-200 data-[state=inactive]:text-[#737373] data-[state=inactive]:font-medium data-[state=inactive]:bg-transparent"
                data-testid="settings-tab-notifications"
              >
                Notifications
              </TabsTrigger>
              <TabsTrigger
                value="domains"
                className="px-3 py-1.5 text-sm font-medium rounded-md transition-all data-[state=active]:bg-white data-[state=active]:text-black data-[state=active]:shadow-md data-[state=active]:border data-[state=active]:border-gray-200 data-[state=inactive]:text-[#737373] data-[state=inactive]:font-medium data-[state=inactive]:bg-transparent"
                data-testid="settings-tab-domains"
              >
                Custom Domains
              </TabsTrigger>
            </div>
          </TabsList>
        </div>

        <TabsContent value="account">
          <Card>
            <CardContent className="p-6 space-y-0">
              <ErrorBoundaryBase>
                <div className="pb-6">
                  <ProfileSettingsForm 
                    isLoading={isLoading} 
                    isSubmitting={isSubmitting}
                    error={hasError}
                    onRetry={handleRetry}
                    noCard={true}
                  />
                </div>
              </ErrorBoundaryBase>
              
              <hr className="border-gray-200" />
              
              <ErrorBoundaryBase>
                <div className="py-6">
                  <SecuritySettingsControls
                    isLoading={isLoading}
                    isSubmitting={isSubmitting}
                    error={hasError}
                    onRetry={handleRetry}
                    noCard={true}
                  />
                </div>
              </ErrorBoundaryBase>
              
              <hr className="border-gray-200" />
              
              <ErrorBoundaryBase>
                <div className="py-6">
                  <PrivacySettingsActions
                    isLoading={isLoading}
                    error={hasError}
                    onRetry={handleRetry}
                    noCard={true}
                  />
                </div>
              </ErrorBoundaryBase>
            </CardContent>
          </Card>
        </TabsContent>
        
        <TabsContent value="notifications">
          <ErrorBoundaryBase> {/* Updated to ErrorBoundaryBase */}
            <NotificationSettingsControls
              isLoading={isLoading}
              error={hasError}
              onRetry={handleRetry}
            />
          </ErrorBoundaryBase>
        </TabsContent>

        <TabsContent value="domains">
          <ErrorBoundaryBase>
            <CustomDomainSettings />
          </ErrorBoundaryBase>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SettingsNew;
